import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const CodeIcon = styled.span`
  display: flex;
  align-items: center;

  svg {
    fill: ${theme.color.white};
    background-color: ${theme.color.designSystem.blackOpacity60};
    border-radius: ${theme.borderRadius.medium};
  }
`;

export const CodeLine = styled.div`
  display: flex;
  counter-increment: row-number;
`;

export const LineNumber = styled.span`
  display: inline-block;
  flex-shrink: 0;
  border-right: 1px solid ${theme.color.designSystem.blackOpacity60};
  width: 18px;
  padding-right ${theme.spacing.small};
  margin-right: ${theme.spacing.small};
  color: ${theme.color.designSystem.blackOpacity60};
  text-align: end;
  user-select: none;

  :before {
    content: counter(row-number);
  }
`;

export const LineContent = styled.span`
  // Fixes an issue where the cursor isn't visible when on an empty line due to the line numbers
  flex-grow: 1;
`;
